import Repository from './repository'
import qs from 'qs'

const resources = {
  lic: '/app/license-support',
  srq: '/app/service-request',
  add: '/app/license-addition',
  sbt: '/app/license-subtraction',
  cst: '/app/customer-info'
}

export default {
  /**
   * 申請書作成API
   * @param type 申請書種別
   * @param data 登録データ
   * @returns {*}
   */
  post (type, data) {
    if (!(type in resources)) {
      throw new Error('APIの呼び方がおかしいです。')
    }
    return Repository.post(`${resources[type]}`, qs.stringify(data))
  },
  /**
   * 申請書PDFダウンロードAPI
   * @param token トークン
   * @returns {*}
   */
  pdfDownload (token, app_id) {
    Repository.defaults.headers['Authorization'] = token ? 'Bearer ' + token : '' // TODO defaultじゃなくて一過性にできないか
    // キャッシュが効かないように後ろにapp_idを付けてURLを毎回違うものにする
    return Repository.get(`/app/pdf-download?app_id=${app_id}`, {responseType: 'blob'})
  },
  /**
   * 申請書データファイルダウンロードAPI
   * @param token トークン
   * @param string password
   * @returns {*}
   */
  getDataFile (token, app_id, password) {
    Repository.defaults.headers['Authorization'] = token ? 'Bearer ' + token : '' // TODO defaultじゃなくて一過性にできないか
    // キャッシュが効かないように後ろにapp_idを付けてURLを毎回違うものにする
    return Repository.get(`/app/data-download?app_id=${app_id}&word=${password}`, {responseType: 'blob'})
  },
  /**
   * 申請書データファイル作成＆ダウンロードAPI
   * @param data
   * @param string password
   * @returns {*}
   */
  postAndGetDataFile (data, app_id, password) {
    // キャッシュが効かないように後ろにapp_idを付けてURLを毎回違うものにする
    return Repository.post(`/app/data-download?app_id=${app_id}&word=${password}`, qs.stringify(data), {responseType: 'blob'})
  }
}



// WEBPACK FOOTER //
// ./src/repositories/applicationsRepository.js